var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseractive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(199 78.288)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path975",
    d: "M0-682.665H20.148v20.148H0Z",
    transform: "translate(0 682.665)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4752",
    "data-name": "Mask Group 4752",
    transform: "translate(-199 -78.288)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g969",
    transform: "translate(200.926 763.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g971",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g973",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g979",
    transform: "translate(0.787 0.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path981",
    d: "M0-305.379a9.287,9.287,0,0,0,9.287,9.287,9.287,9.287,0,0,0,9.287-9.287,9.287,9.287,0,0,0-9.287-9.287A9.287,9.287,0,0,0,0-305.379Z",
    transform: "translate(0 314.666)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g983",
    transform: "translate(7.044 4.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path985",
    d: "M-196.685-98.342a2.991,2.991,0,0,1-2.991,2.991,2.991,2.991,0,0,1-2.991-2.991,2.991,2.991,0,0,1,2.991-2.991A2.991,2.991,0,0,1-196.685-98.342Z",
    transform: "translate(202.666 101.333)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g987",
    transform: "translate(5.783 12.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path989",
    d: "M-287.364-60.817a5.032,5.032,0,0,0-3.9-1.85h-.934a5.032,5.032,0,0,0-3.9,1.85",
    transform: "translate(296.103 62.667)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseractive);
export default __webpack_public_path__ + "static/media/useractive.550fc141b6fd887c52937e8b34e1907e.svg";
export { ForwardRef as ReactComponent };